import React, { useEffect, useMemo, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import tokens from '../../theme/tokens';
import { useFotoUsuario } from '../../utils/fotos';

// Fotos antigas ficavam em public/players/<PrimeiroNome>.jpg (ou nome completo).
function legacySources(name) {
  if (!name) return [];
  const clean = name.trim();
  return [
    `/players/${clean.split(' ')[0].replace(/ /g, '_')}.jpg`,
    `/players/${clean.replace(/ /g, '_')}.jpg`,
  ];
}

function initials(name = '') {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return `${first}${last}`.toUpperCase();
}

/**
 * Foto do jogador: usa a foto de perfil (R2) quando existe, depois as fotos
 * estáticas antigas e, por fim, as iniciais do nome.
 * Com `userId` (e sem `src`), busca a foto de perfil atual do usuário.
 */
const PlayerAvatar = ({ src, userId, name, size = 40, ring = false, sx, ...props }) => {
  const fotoPerfil = useFotoUsuario(src ? null : userId);
  const sources = useMemo(
    () => [...new Set([src || fotoPerfil, ...legacySources(name)].filter(Boolean))],
    [src, fotoPerfil, name]
  );
  const [index, setIndex] = useState(0);

  useEffect(() => setIndex(0), [sources]);

  return (
    <Avatar
      alt={name}
      src={sources[index]}
      imgProps={{ onError: () => setIndex((i) => i + 1), loading: 'lazy' }}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        fontWeight: 700,
        bgcolor: tokens.color.inkSoft,
        color: '#fff',
        ...(ring && { border: `3px solid ${tokens.color.brand}` }),
        ...sx,
      }}
      {...props}
    >
      {initials(name)}
    </Avatar>
  );
};

export default PlayerAvatar;
